import { FlexRow, StyledTooltipProps } from '@gorila-shared-ui/components';
import { HeadingXSmall, LabelMedium, LabelSmall } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { AssetCore } from '../../types/asset';
import { getAssetTitle } from '../../utils/assets';
import { StyledTooltip } from '../ui/StyledTooltip';
import { BatteryPercentage } from './BatteryPercentage';

type Props = {
  asset: AssetCore;
  positionType?: string;
  batteryPercentage?: number;
};

function AssetHeader({ asset, batteryPercentage, positionType }: Readonly<Props>) {
  const { theme, classes } = useStyles();

  const tooltipProps: Omit<StyledTooltipProps, 'children' | 'content'> = {
    placement: 'top',
    ignoreBoundary: true,
    showArrow: false,
  };

  return (
    <FlexRow
      centered
      gap={theme.sizing.scale800}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredStart}
      >
        <HeadingXSmall margin={0}>{getAssetTitle(asset)}</HeadingXSmall>
        <LabelMedium
          margin={0}
          color={theme.colors.contentSecondary}
        >
          ({asset.label})
        </LabelMedium>
      </FlexRow>
      {(positionType || batteryPercentage !== undefined) && (
        <FlexRow
          centered
          gap={theme.sizing.scale200}
        >
          {positionType && (
            <StyledTooltip
              {...tooltipProps}
              content="Tipo de posición"
            >
              <LabelSmall>{positionType}</LabelSmall>
            </StyledTooltip>
          )}
          {batteryPercentage !== undefined && (
            <StyledTooltip
              {...tooltipProps}
              content="Batería de Reserva"
            >
              <BatteryPercentage percentage={batteryPercentage} />
            </StyledTooltip>
          )}
        </FlexRow>
      )}
    </FlexRow>
  );
}

export default memo(AssetHeader);
